<template>
    <div class="FosterParentTraining">
        <div class="row">
            <div class="col">
                <button class="btn btn-success" @click="OpenCreateModal()"><font-awesome-icon :icon="['fa', 'plus']" /> Add Training Record</button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <vuetable :fields="Fields"
                          :data="TrainingRecords"
                          pagination-path=""
                          :api-mode="false"
                          class="vue-datatable"
                          ref="datatable"
                          :row-class="onRowClass">

                    <template slot="Parent1" scope="props">
                        <span v-if="props.rowData.FosterParentTrainingRecordID1" @click="OpenEditModal(props.rowData.FosterParentTrainingRecordID1, 1, props.rowData)"><font-awesome-icon class="olive-green-text pointer" :icon="['fa', 'check']" /></span>
                    </template>
                    <template slot="Parent2" scope="props">
                        <span v-if="props.rowData.FosterParentTrainingRecordID2" @click="OpenEditModal(props.rowData.FosterParentTrainingRecordID2, 2, props.rowData)"><font-awesome-icon class="olive-green-text pointer" :icon="['fa', 'check']" /></span>
                    </template>
                </vuetable>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />

        <!--ADD TRAINING MODAL-->
        <b-modal ref="modal-add" size="lg" title="Add Training Record" hide-footer>
            <b-container v-if="TargetTrainingRecord.FosterParents">
                <b-form @submit="CreateTrainingRecord" ref="form-create" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Training Info</h3>
                            <div class="form-group">
                                <label>Name of Training:</label>
                                <input type="text" name="Name" v-model="TargetTrainingRecord.Name" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Date of Training:</label>
                                <flat-pickr name="TrainingDate" v-model="TargetTrainingRecord.TrainingDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Hours:</label>
                                <input type="number" name="Hours" v-model="TargetTrainingRecord.Hours" class="form-control" required step="0.01" />
                            </div>
                            <div class="form-group">
                                <label>Category:</label>
                                <select type="text" class="form-control" name="Category" required v-model="TargetTrainingRecord.Category">
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Racial Equity and Social Justice">Racial Equity and Social Justice</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Understanding and Working Within the Child Welfare System">Understanding and Working Within the Child Welfare System</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Parenting and Family Management">Parenting and Family Management</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Caregiver Self-Awareness and Development">Caregiver Self-Awareness and Development</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="- Pre-Service Training -">- Pre-Service Training - (hours won't sum)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Format:</label>
                                <select type="text" class="form-control" required name="Format" v-model="TargetTrainingRecord.Format">
                                    <option value=""></option>
                                    <option value="In Person">In Person</option>
                                    <option value="Virtual Live">Virtual Live</option>
                                    <option value="Online Webinar">Online Webinar</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Trainer Name:</label>
                                <input type="text" name="Trainer" v-model="TargetTrainingRecord.Trainer" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Description of Training (optional):</label>
                                <textarea name="Description" v-model="TargetTrainingRecord.Description" class="form-control" rows="4"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Attendance:</h3>
                            <div class="form-group">
                                <label>Parents Attended:</label>
                                <div v-for="(parent, index) in ParentOptions">
                                    <b-form-checkbox v-model="TargetTrainingRecord.FosterParents[index]"
                                                     :value="parent.value"
                                                     :unchecked-value="null"
                                                     size="lg">
                                        {{ parent.text }}
                                    </b-form-checkbox>
                                    <b-form-file v-if="TargetTrainingRecord.FosterParents[index]" class="form-control"
                                                 :name="'CertificateFileParent' + (index + 1)"></b-form-file>
                                </div>

                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelCreateModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--EDIT TRAINING MODAL-->
        <b-modal ref="modal-edit" size="lg" title="Edit Training Record" hide-footer>
            <b-container v-if="TargetTrainingRecord.TrainingRecordID">
                <b-form @submit="UpdateTrainingRecord" ref="form-edit" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Training Info</h3>
                            <div class="form-group">
                                <label>Name of Training:</label>
                                <input type="text" name="Name" v-model="TargetTrainingRecord.Name" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Date of Training:</label>
                                <flat-pickr name="TrainingDate" v-model="TargetTrainingRecord.TrainingDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Hours:</label>
                                <input type="number" name="Hours" v-model="TargetTrainingRecord.Hours" class="form-control" required step="0.01" />
                            </div>
                            <div class="form-group">
                                <label>Category:</label>
                                <select type="text" name="Category" class="form-control" required v-model="TargetTrainingRecord.Category">
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Racial Equity and Social Justice">Racial Equity and Social Justice</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Understanding and Working Within the Child Welfare System">Understanding and Working Within the Child Welfare System</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Parenting and Family Management">Parenting and Family Management</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="Caregiver Self-Awareness and Development">Caregiver Self-Awareness and Development</option>
                                    <option v-if="FamilyRecordData.FamilyProgramMembership.SubProgramName == 'West Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'North Sound Foster' || FamilyRecordData.FamilyProgramMembership.SubProgramName == 'South Sound Foster'" value="- Pre-Service Training -">- Pre-Service Training - (hours won't sum)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Format:</label>
                                <select type="text" class="form-control" required name="Format" v-model="TargetTrainingRecord.Format">
                                    <option value=""></option>
                                    <option value="In Person">In Person</option>
                                    <option value="Virtual Live">Virtual Live</option>
                                    <option value="Online Webinar">Online Webinar</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Trainer Name:</label>
                                <input type="text" name="Trainer" v-model="TargetTrainingRecord.Trainer" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Description of Training (optional):</label>
                                <textarea name="Description" v-model="TargetTrainingRecord.Description" class="form-control" rows="4"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Attendance:</h3>
                            <div class="form-group">
                                <label>Parent Attended:</label>
                                <p>{{ TargetTrainingRecord.ParentName }}</p>
                                <p v-if="TargetTrainingRecord.CertificateFileID">Certificate on File
                                    <input name="CertificateFileID" type="hidden" v-model="TargetTrainingRecord.CertificateFileID" /> <font-awesome-icon @click="RemoveCertificateIDFromEditObj()" class="red pointer" :icon="['fa', 'trash-alt']" /> <font-awesome-icon @click="DownloadCertificateFile()" class="pointer" :icon="['fa', 'download']" />
                                </p>
                                <b-form-file v-else class="form-control"
                                             name="CertificateFile"></b-form-file>

                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEditModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteTrainingRecord(TargetTrainingRecord.TrainingRecordID)">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);


    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    //import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    export default {
        name: 'FosterParentTraining',
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                Fields: [
                    {
                        name: 'TrainingDate',
                        title: "Date",
                        callback: 'formatDate|MM/DD/YY',
                        sortField: 'TrainingDate'
                    },
                    {
                        name: 'Name',
                        title: 'Training',
                        sortField: 'Name'
                    },
                    {
                        name: 'Hours',
                        title: 'Hours',
                        sortField: 'Hours'
                    },
                    {
                        name: 'Category',
                        title: 'Category',
                        sortField: 'Category'
                    },
                    {
                        name: '__slot:Parent1',
                        title: 'Parent1',
                    },
                    {
                        name: '__slot:Parent2',
                        title: 'Parent2',
                    }
                ],
                EditMode: false,
                TrainingRecords: [],
                Filters: {

                },
                TargetTrainingRecord: {},
                TrainingRecordSchema: {
                    FosterParents: [null,null],
                    TrainingDate: "",
                    Hours: "",
                    Name: "",
                    Description: "",
                    Category: "",
                    CategoryOther: "",
                    Format: "",
                    Trainer: "",
                    CertificateFile: "",
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: true
                }
            };
        },
        methods: {
            //MODAL CONTROL
            //Open Create Modal
            OpenCreateModal() {
                this.TargetTrainingRecord = JSON.parse(JSON.stringify(this.TrainingRecordSchema));
                this.$refs['modal-add'].show();
            },
            CancelCreateModal() {
                this.$refs['modal-add'].hide();
            },
            //Open Edit Modal
            OpenEditModal(trainingRecordID, slotNum, trainingRecordOutputModel) {
                this.$set(this, "TargetTrainingRecord", JSON.parse(JSON.stringify(trainingRecordOutputModel)));
                //this.TargetTrainingRecord = JSON.parse(JSON.stringify(trainingRecordOutputModel));
                this.$set(this.TargetTrainingRecord, "TrainingRecordID", trainingRecordID);
                //this.TargetTrainingRecord.TrainingRecordID = trainingRecordID;
                this.$set(this.TargetTrainingRecord, "ParentName", slotNum == 1 ? trainingRecordOutputModel.FosterParentName1 : trainingRecordOutputModel.FosterParentName2);
                //this.TargetTrainingRecord.ParentName = slotNum == 1 ? trainingRecordOutputModel.FosterParentName1 : trainingRecordOutputModel.FosterParentName2;
                this.$set(this.TargetTrainingRecord, "CertificateFileID", slotNum == 1 ? trainingRecordOutputModel.CertificateFileID1 : trainingRecordOutputModel.CertificateFileID2);
                //this.TargetTrainingRecord.CertificateFileID = slotNum == 1 ? trainingRecordOutputModel.CertificateFileID1 : trainingRecordOutputModel.CertificateFileID2;

                this.$refs['modal-edit'].show();
            },
            RemoveCertificateIDFromEditObj() {
                //let vm = this;
                this.$set(this.TargetTrainingRecord, "CertificateFileID", null);
                console.log("nulling certificate file");

                //this.$nextTick(function () {
                //    console.log("next tiock initiated");
                //    vm.$mount();
                //})
                //this.TargetTrainingRecord.CertificateFileID = null;
            },
            CancelEditModal() {
                this.$refs['modal-edit'].hide();
            },
            //ENDPOINTS
            //Create
            CreateTrainingRecord(e) {
                e.preventDefault();
                let vm = this;

                let form = this.$refs['form-create'];
                let formData = new FormData(form);


                this.TargetTrainingRecord.FosterParents.forEach(function (parent, index) {
                    //vm.TargetTrainingRecord['FosterParentID' + (index + 1)] = parent
                    formData.append('FosterParentID' + (index + 1), parent);
                });

                

                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterParents/TrainingRecords/TrainingRecord", formData, this.CreateTrainingRecordSuccess, () => { }, true);
            },
            CreateTrainingRecordSuccess(response) {
                this.ReadTrainingRecords();
                this.$refs['modal-add'].hide();
            },
            //Read
            ReadTrainingRecords() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterParents/TrainingRecords/TrainingRecord", { FosterFamilyID: this.FamilyRecordData.Id }, this.ReadTrainingRecordsSuccess, () => { }, true);
            },
            ReadTrainingRecordsSuccess(response) {
                this.TrainingRecords = response.data.data;
                console.log("Data table about to refresh")
                this.$refs.datatable.refresh();
            },
            //Update
            UpdateTrainingRecord(e) {
                e.preventDefault();
                let vm = this;

                let form = this.$refs['form-edit'];
                let formData = new FormData(form);
                formData.append("TrainingRecordID", this.TargetTrainingRecord.TrainingRecordID);

                this.$MasterAPI.ExecuteRequest("PUT", "Foster/FosterParents/TrainingRecords/TrainingRecord", formData, this.UpdateTrainingRecordSuccess, () => { }, true);
            },
            UpdateTrainingRecordSuccess(response) {
                this.ReadTrainingRecords();
                this.$refs['modal-edit'].hide();
            },
            DownloadCertificateFile() {
                this.$MasterAPI.ExecuteFileRequest("Core/Files/GetFilecontent/CertificateFile.pdf", { FileID: this.TargetTrainingRecord.CertificateFileID });
            },
            //Delete
            DeleteTrainingRecord(recordID) {
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterParents/TrainingRecords/DeleteTrainingRecord", { Id: recordID }, this.DeleteTrainingRecordSuccess, () => { }, true);
            },
            DeleteTrainingRecordSuccess(response) {
                this.TargetTrainingRecord = {};
                this.ReadTrainingRecords();
                this.$refs['modal-edit'].hide();
            },

            //MISC METHODS
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            Vuetable,
            flatPickr
        },
        mounted() {
            let vm = this;
            let fieldIndex = 4
            this.FamilyRecordData.Family.Parents.filter(f => f.EndDate == null).sort((a, b) => (a.Parent.Person.FirstName > b.Parent.Person.FirstName) ? 1 : -1).forEach(function (parentMem) {
                if (fieldIndex < 6) {
                    vm.Fields[fieldIndex].title = parentMem.Parent.Person.FirstName;
                    fieldIndex++;
                }
            });
            vm.$refs.datatable.refresh();
            vm.$refs.datatable.normalizeFields();
            vm.ReadTrainingRecords();
        },
        computed: {
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            },
            FamRegion: function () {

            },
            ParentOptions: function () {
                let output = [];
                this.FamilyRecordData.Family.Parents.filter(f => f.EndDate == null).forEach(function (parentMem) {
                    output.push(
                        {
                            text: parentMem.Parent.Person.FullName,
                            value: parentMem.Parent.Id
                        }
                    )
                });
                return output;
            }
        }
    }
</script>

<style scoped>

</style>